module.exports = Object.freeze({
  DATE: "date",
  USER: "user",
  TEXT: "text",
  TIMEZONE: "timezone",
});
